<template>
    <div class="form-dynamic-wrapper mb-2">
        <b-row class="pr-5">
            <b-col md="4">
                <b-form-group label="Name">
                    <b-form-input v-model="kelengkapan.name" name="kelengkapanName" placeholder="Name" class="mr-2" required></b-form-input>
                </b-form-group>
            </b-col>
            <!-- <b-col cols="10" md="4">
                    <label for="file">File PDF</label>
                    <FormulateForm v-model="pdf">
                    <FormulateInput v-if=" kelengkapan.url != null && kelengkapan.url.length != 0"
                    id="urlPDF"
                    name="urlPDF"
                    ref="urlPDF"
                    type="file"
                    :value="kelengkapan.url"
                    help="Format Harus PDF"
                    accept=".pdf"
                    validation="mime:application/pdf"
                    multiple
                 
                    />
                    <FormulateInput v-else
                    type="file"
                    name="file"
                    help="Format Harus PDF"
                    validation="mime:application/pdf"
                    accept=".pdf"
                    fileRemove
                    multiple
                    />
                </FormulateForm>
            </b-col>
            <b-col cols="2" class="mt-4">
                <div v-if="pdf != null "> 
                    <div v-if="pdf.urlPDF != undefined || pdf.urlPDF != null ">
                        <div v-for="file of pdf.urlPDF.files">            
                            <b-button size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreview( file.file.size != null ?file.file : $baseFilePath + file.file.previewData )">View</b-button>                
                        </div>
                    </div> 

                    <div v-if="pdf.file != undefined || pdf.file != null ">
                        <div v-for="file of pdf.file.files">            
                            <b-button size="sm" class="mb-3" variant="pgiBtn" @click="openModalPreview( file.file.size != null ?file.file : $baseFilePath + file.file.previewData )">View</b-button>                
                        </div>
                    </div> 
                </div>
            </b-col>             -->
        </b-row>
        <div class="form-dynamic-deleteWrapper">
            <b-row>
                <b-button variant="dynamicDeleteBtn" name="deleteKelengkapan" :disabled="kelengkapan.id == 0" @click="$emit('nonAktif', kelengkapan.index)"><i class="fa fa-minus"></i></b-button>
                <b-button variant="dynamicDeleteBtn ml-2 mr-2" name="deleteKelengkapan"  @click="$emit('remove', kelengkapan.index)"><i class="fa fa-times"></i></b-button>
            </b-row>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import VueFormulate from '@braid/vue-formulate'

Vue.use(VueFormulate)

export default {
    name: 'kelengkapan',
    props: {
        kelengkapan: { type: Object, required: true },
        length: { type: Number, required: true },
        filePDF : { type : Array},
    },
    
    data(){
        return{
            pdf: {
                urlPDF : {
                    fileList:[]
                }
            },
            //activePdfPreview: null,


            pdfRecords : [],
            pdfNewVal:[],
        }
    },
    
    methods : {
     
        toBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })

        },
        openModalPreview(pdf){
            if(pdf.size != null){  
                    this.toBase64(pdf).then(async base64 => {   
                    this.$emit('openModalPreviewPDFSpekKel' ,base64)
                 })
                
            }

            this.$emit('openModalPreviewPDFSpekKel' ,pdf)
                
        },
        change(){
        }
        
        
    },

    watch: {
        "filePDF": function(newValue){
            this.pdfRecords = newValue 
            this.pdf.urlPDF.files = newValue
        },
    },
    
}
</script>
